import { createRow } from "../../utilities/CreateRow";
import { createInfoCell, createSwitchCell } from "../../utilities/CreateCell";
import axios from "../../network/ApiConfig";
import { QueryClient } from "react-query";
import { BaseSyntheticEvent } from "react";
import { toastFail } from "../../utilities/toast";

export const createFieldProcessorRows = (
  data: any[],
  queryClient: QueryClient,
  loadingMap: Record<number, boolean>,
  setLoadingMap: (map: Record<number, boolean>) => void,
) => {
  return data.map((user) =>
    createRow(
      createInfoCell(user.username),
      createInfoCell(user.email),
      createSwitchCell(
        user.activated,
        user.id,
        async (e: BaseSyntheticEvent) => {
          try {
            const response = await axios.put(
              `/admin/users/${user.id}/activate-deactivate?activate=${e.target.checked}`,
            );

            if (response.status === 200) {
              queryClient.invalidateQueries("fieldProcessors");
            }
          } catch (error: any) {
            if (error.response) {
              toastFail(error.response.data);
            }
          }
        },
      ),
    ),
  );
};
